import type { AnswerT } from '../../..';
import { resolveTaskQuestionnaire } from '../../resolver/common/task-questionnaire';
import { resolveImageData } from '../../resolver/image/image-resolver';
import type { ResolvedValues, ResolveValuePermutations } from '../../type/common/types';
import type { QAAnnotationLabelAnswersInput } from '../../type/qa-engine';
import type { ImageResolver } from '../../type/resolver';
import { calculateCrossProductOfResolvedValues } from '../calculate-cross';
import { QaCheckError } from '../error';
export const getFetchedDataForRule = (bindings: ImageResolver[], args: {
  annotationLabelAnswers: QAAnnotationLabelAnswersInput[];
  taskQuestionnaire: AnswerT;
}): ResolveValuePermutations<'ANNOTATION' | 'TASK_QUESTIONNAIRE'> | QaCheckError => {
  const {
    annotationLabelAnswers,
    taskQuestionnaire
  } = args;
  const aliasToResolvedValueMap: {
    [alias: string]: ResolvedValues<'ANNOTATION' | 'TASK_QUESTIONNAIRE'>;
  } = {};
  for (const binding of bindings) {
    switch (binding.entityType) {
      case 'ANNOTATION':
        {
          const resolvedValues = resolveImageData(binding, annotationLabelAnswers);
          if (resolvedValues instanceof QaCheckError) {
            return resolvedValues;
          }
          aliasToResolvedValueMap[binding.alias] = resolvedValues;
          break;
        }
      case 'TASK_QUESTIONNAIRE':
        {
          const resolvedValues = resolveTaskQuestionnaire(binding, taskQuestionnaire);
          if (resolvedValues instanceof QaCheckError) {
            return resolvedValues;
          }
          aliasToResolvedValueMap[binding.alias] = resolvedValues;
          break;
        }
    }
  }
  return calculateCrossProductOfResolvedValues(aliasToResolvedValueMap);
};